module.exports = __webpack_public_path__ + "img/0.a7b57c57.png";